<nav [class.onNavDown]="nav_down">
    <div class="nav_inner">
        <div class="nav_logo" title="Om Sai Enterprises - Home">
            <a (click)="onReturnHome()">
                <h4>om sai enterprises</h4>
            </a>
        </div>
        <div (click)="onClick()" class="checkbtn" title="Menu">
            <div class="wrapper-menu" [class.open]="check">
                <div class="line-menu half start"></div>
                <div class="line-menu"></div>
                <div class="line-menu half end"></div>
            </div>
        </div>
    </div>
    <div class="navlinks" [class.show]="check">
        <div class="nav_items">
            <ul>
                <li>  
                    <a [routerLinkActive]="['active']" (click)="onHome()">
                        <h2>home</h2>
                        <div class="nav_indicator"></div>
                    </a>
                </li>
                <li>
                    <a [routerLinkActive]="['active']" (click)="onAbout()">
                        <h2>who we are</h2>
                        <div class="nav_indicator"></div>
                    </a>
                </li>
                <li>
                    <a [routerLinkActive]="['active']" (click)="onExpertise()">
                        <h2>expertise</h2>
                        <div class="nav_indicator"></div>
                    </a>
                </li>
                <li>
                    <a [routerLinkActive]="['active']"  (click)="onProducts()">
                        <h2>products</h2>
                        <div class="nav_indicator"></div>
                    </a>
                </li>
                <li>
                    <a [routerLinkActive]="['active']" (click)="onContact()">
                        <h2>contact US</h2>
                        <div class="nav_indicator"></div>
                    </a>
                </li>
            </ul>
        </div>
    </div>
</nav>
<a [class.onScroll]="scroll_down" (click)="scrollToTop()">
    <div class="back_to_top">
        <i class="fa fa-long-arrow-up" aria-hidden="true"></i>
    </div>
</a>